<template>
  <div class="wrap-bg wrap-back-manage wrap-back-user-manage">
    <v-breadcrumb :breadcrumb-list="breadcrumbList" />
    <div class="bg-white pd-btm15 breadcrumb-btm-con-box">
      <h3 class="f-fs16 f-fwn bor-btm-gray pd15">用户管理</h3>
      <div class="main-con">
        <!---->
        <section class="filter-box pd15 f-df f-ai">
          <el-input
            v-model="inpName"
            :clearable="true"
            placeholder="请输入账号或姓名"
            class="inp-name"/>
          <div class="f-df f-ai mg-left15">
            <el-button type="primary" size="small" @click="refreshList">查询</el-button>
            <el-button size="small" plain class="add-btn" @click="addBtn">新增</el-button>
          </div>
        </section>
        <v-table-list
          :is-loading="isLoading"
          :table-head="tableHead"
          :table-btn="tableBtn"
          :page-list="pageList"
          :current-page="pageObj.page"
          :page-size="pageObj.pageSize"
          :total-size="pageObj.totalSize"
          :is-show-selection="false"
          :is-table-operation-btn="true"
          class="bg-white pd-row15"
          @rowOperatBtn="rowOperatBtn"
          @sizeChange="sizeChange"
          @currentChange="currentChange" />
      </div>
    </div>
    <!--弹窗-->
    <div
      v-if="isShowPopTip"
      v-loading="isSaveLoading"
      element-loading-text="保存中"
      element-loading-spinner="el-icon-loading"
      class="popTip f-df f-ai f-jc f-tal">
      <div class="popTip-con bg-white pd-btm15">
        <h3 class="f-fwn f-df f-jcsb color-dark bor-btm-gray pd-column10-row15 popTip-title">
          <span class="color-gray-76">重置密码</span>
          <i class="el-icon-close f-fs3 color-91a f-fwb f-csp" @click="cancleBtn"></i>
        </h3>
        <div class="pop-main-con mg-top10">
          <v-list-filter
            v-model="dialogBindValue"
            :form-arr="dialogForm"
            :form-rules="dialogFormRules"
            :is-add-btn="false"
            :is-group-btn="true"
            form-item-position="vertical"
            class="list-filter bg-white"
            @changeFormBind="changeFormBind"
            @filterCheckBtn="saveBtn"
            @filterResetBtn="cancleBtn">
            <p class="f-fs1 f-lh24 color-gray-76 mg-top15 warn-piptip-txt">
              说明：密码至少6个字符，可由数字、大写字母、小写字母或特殊字符组成
            </p>
          </v-list-filter>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vBreadcrumb from '@/components/breadcrumb.vue'
import mixin from '@/mixin/list.js'
import vTableList from '@/components/table-list.vue'
import vListFilter from '@/components/form-filter/index.vue'
import $filterCommon from '@/components/form-filter/index.js'
import pageConfig from './page.config.js'
import {
  updatePassword,
  getList
  // getListTotal
} from '@/api/backManage/userManage.js'
export default {
  components: {
    vBreadcrumb,
    vTableList,
    vListFilter
  },
  mixins: [mixin],
  data() {
    return {
      breadcrumbList: [
        {
          name: '后台管理'
        },
        {
          name: '用户管理'
        }
      ],
      isLoading: false,
      inpName: '',
      tableHead: [], // 表头
      tableBtn: [], // 表格操作按钮组
      pageList: [{}, {}], // 产线分析数据
      dialogFormRules: JSON.parse(JSON.stringify(pageConfig.dialogFormRules)),
      pageObj: {
        page: 1,
        pageSize: 10,
        totalSize: 0,
        sortIndex: '', // issue_date按发布时间排序，impl_date按实施时间排序
        sortRule: '1' // 1倒序，2升序
      },
      isShowPopTip: false,
      isSaveLoading: false,
      dialogBindValue: {},
      dialogForm: []
    }
  },
  mounted() {
    this.$bus.$on('updateUser', data => {
      // 更新列表
      this.getList(this.pageObj.page, this.pageObj.pageSize)
    })
    // 内容列表
    this.tableHead = JSON.parse(JSON.stringify(pageConfig.tableHead))
    this.tableBtn = JSON.parse(JSON.stringify(pageConfig.tableBtn))
    // 页面初始化
    this.refreshList()
    // 弹窗初始化
    this.dialogInit()
  },
  methods: {
    // 参数
    getParam() {
      return {
        keyword: this.inpName
      }
    },
    // 获取内容列表
    getList(currentPage, pageSize) {
      this.isLoading = true
      this.pageObj.page = currentPage || 1
      pageSize && (this.pageObj.pageSize = pageSize)
      this.pageList = []
      !currentPage && (this.pageObj.totalSize = -1)
      getList(Object.assign(this.getParam(), {
        startPageNum: this.pageObj.page,
        pageSize: this.pageObj.pageSize,
        sortItem: this.pageObj.sortIndex,
        isSortMax: this.pageObj.sortRule
        // isPopular: this.pageObj.isPopular ? 1 : 0
      })).then(res => {
        this.isLoading = false
        const data = res.data || {}
        this.pageList = (data.items || []).map((item, index) => {
          item.status = item.enable * 1 === 1 ? '启用' : '停用'
          item.$index = index + 1
          return item
        })
        !currentPage && (this.pageObj.totalSize = data.total || 0)
      })
    },
    // 获取产线分析数据总数
    getListTotal() {
    },
    // 表格按钮
    rowOperatBtn(rowData, item) {
      if (item.id === 'edit') {
        // 编辑
        this.$router.push({
          path: '/userManage/detail',
          query: {
            id: rowData[0].id,
            pageType: 'edit'
          }
        })
      } else {
        // 修改密码
        this.dialogBindValue = Object.assign(this.dialogBindValue, rowData[0])
        this.isShowPopTip = true
      }
    },
    // 添加
    addBtn() {
      this.$router.push({
        path: '/userManage/detail',
        query: {
          pageType: 'add'
        }
      })
    },
    // 密码修改初始化
    dialogInit() {
      // 表单
      const formArr = pageConfig.dialogForm
      // 初始化所有筛选条件集合
      const filterObj = $filterCommon.filterChooseHandle(formArr, [])
      // 表单绑定
      this.dialogBindValue = filterObj.filterChooseObj
      this.dialogForm = filterObj.filterList
    },
    // 弹窗数据绑定
    changeFormBind(bindForms, item, value) {
      this.dialogBindValue = bindForms
    },
    // 保存
    saveBtn() {
      this.isSaveLoading = true
      updatePassword({
        password: this.dialogBindValue.password,
        id: this.dialogBindValue.id
      }).then(res => {
        this.isSaveLoading = false
        if (res.data && res.status * 1 === 200) {
          this.$message({
            type: 'success',
            message: '修改密码成功！'
          })
          this.isShowPopTip = false
          this.getList(this.pageObj.page, this.pageObj.pageSize)
        } else {
          this.$message({
            type: 'error',
            message: res.message || '修改密码失败！'
          })
        }
      })
    },
    // 取消
    cancleBtn() {
      this.isShowPopTip = false
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.filter-box{
  & .inp-name{
    width: 300px;
  }
}
.popTip{
  & .popTip-con{
    width: 500px;
    min-height: 320px;
    max-height: 80vh;
    border-radius: 3px;
    & .list-filter{
      padding-left: 30px;
    }
    & .warn-piptip-txt{
      margin-top: 30px;
      margin-left: 12px;
    }
  }
}
/deep/.popTip-con .filter-group-btn{
  margin-top: 30px;
}
</style>
